import { ReactNode } from "react";
import SimpleGrid from "@vfuk/core-simple-grid";
import Spacing from "@vfuk/core-spacing";

const DetailsRow = ({ children }: { children: ReactNode }) => (
  <Spacing
    spacingLevel={{
      top: 2,
    }}
  >
    <SimpleGrid
      columns={{
        sm: 2,
        lg: 3,
      }}
      spacing={3}
    >
      {children}
    </SimpleGrid>
  </Spacing>
);

export default DetailsRow;
